export const startLoading = () => async (dispatch) => {
  dispatch({ type: "LOADING_STARTED" });
};

export const stopLoading = () => async (dispatch) => {
  dispatch({ type: "LOADING_COMPLETED" });
};
